import { useEffect, useState } from "react";
import DataTable, { Column } from "../../components/DataTable";
import { ClassSubject } from "../../types/classesTypes";
import classesApis from "../../api/classesApis";
import { useParams } from "react-router-dom";

interface Props {
  selectedSubjects: number[];
  onSelectSubjects: (ids: number[]) => void;
  onAssignNewStaff: (subjectId: number) => void;
  refreshKey: number;
}

export default function SubjectsTab({
  selectedSubjects,
  onSelectSubjects,
  onAssignNewStaff,
  refreshKey,
}: Props) {
  const { classId } = useParams<{ classId: string }>();
  const parsedClassId = Number(classId);

  const [subjects, setSubjects] = useState<ClassSubject[]>([]);

  useEffect(() => {
    if (!parsedClassId || Number.isNaN(parsedClassId)) return;

    classesApis.fetchClassSubjects(parsedClassId).then((res) => {
      if (res?.data) setSubjects(res.data);
    });
  }, [parsedClassId, refreshKey]);

  const toggleSelect = (subjectId: number) => {
    if (selectedSubjects.includes(subjectId)) {
      onSelectSubjects(selectedSubjects.filter((id) => id !== subjectId));
    } else {
      onSelectSubjects([...selectedSubjects, subjectId]);
    }
  };

  const toggleSelectAll = () => {
    if (selectedSubjects.length === subjects.length) {
      onSelectSubjects([]);
    } else {
      onSelectSubjects(subjects.map((s) => s.id));
    }
  };

  const columns: Column<ClassSubject>[] = [
    {
      label: (
        <input
          type="checkbox"
          className="w-3 h-3"
          checked={
            subjects.length > 0 && selectedSubjects.length === subjects.length
          }
          onChange={toggleSelectAll}
        />
      ),
      accessor: "select",
      render: (item) => (
        <input
          type="checkbox"
          className="w-3 h-3"
          checked={selectedSubjects.includes(item.id)}
          onChange={() => toggleSelect(item.id)}
        />
      ),
    },
    {
      label: "SL NO.",
      accessor: "id",
      render: (_,index) => (
        <div className="text-start">
          {index + 1}
        </div>
      ),
    },
    {
      label: "Subjects List",
      accessor: "subList",
      searchable: true,
      render: (item) => (
        <div className="text-start">
          <div className="font-bold text-sm text-neutral-400">
            {item.subject.subjectName}
          </div>
        </div>
      ),
    },
    {
      label: "Staff Assigned",
      accessor: "staff",
      searchable: true,
      render: (item) => (
        <div className="text-start">
          <div className="font-bold text-sm text-neutral-400">
            {item.staff.fullName}
          </div>
        </div>
      ),
    },
    {
      label: "Action",
      accessor: "action",
      searchable: false,
      render: (item) => (
        <button
          onClick={() => onAssignNewStaff(item.subjectId)}
          className="px-2 py-1 text-nowrap text-xs text-warning-700 bg-warning-50 rounded-[4px] font-medium"
        >
          Assign New Staff
        </button>
      ),
    },
  ];
  return (
    <div className="bg-white px-6 py-5 rounded-lg">
      <DataTable columns={columns} data={subjects} />
    </div>
  );
}
